import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./scss/contactlist.module.scss";
import { Menu, Dropdown, Modal, Tooltip } from "antd";
import { deleteAllRecentCalls, deleteRecentCalls, getCallHistoryByExt, getCallLogsCDR } from "../../../base/callService/callsApiService";
import { initialStateModel, UserDetails } from "../../../models/model";
import { URButton } from "../../../shared/widgets/button";
import { initiateCall, initiateFlipCall, initiateGroupCall, sendDirectVideoCallRequest } from "../../../base/callService/callService";
import PopoverModule from "../callsWidgets/PopoverModule/PopoverModule";
import { URCheckBoxCall } from "../../../shared/widgets/checkbox/callCheckBox";
import { URChatLeftSkeleton } from "../../../shared/skeletonLoading/chatLeftSkeleton";
import {
  findCallHost,
  findTileSize,
  frameCallProfile,
  getCurrentCallDetail,
  goCalltoChat,
  handlingKeyMovement,
  max_Call_Window,
  milliSecondsConverter,
  searchHighlight,
  selectList,
  timeStampConverter,
  toastInformation
} from "../../../base/callService/common";
import { storeCallHistory, storeChatWindow, storeLogs, storeParticularLog } from "../../../base/callService/store_mining";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../styles/images/Lottie Animation.json";
import NoContent from "../../../shared/widgets/noContent";
import callblank from "../../../styles/images/empty_states/emptycall.svg";
import store from "../../../context/store/store";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import _ from "lodash";
import { type } from "os";
import { log } from "console";
import teamIcn from "../../../styles/images/teamimg.svg";
//import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";

type callListState = {
  isClear: boolean;
  listOffset: number;
  filterType: string;
  tempList: any;
  doneList: any;
  isModalVisible: boolean;
};
type callListProps = {
  openGroup: any;
}

export const CallLists = ({ openGroup }: callListProps) => {

  const [callListState, setcallliststate] = useState<callListState>({
    isClear: false,
    listOffset: 1,
    filterType: "All Calls",
    tempList: [],
    doneList: [],
    isModalVisible: false
  });
  const { tempList, isClear, filterType, doneList, isModalVisible } = callListState;
  const history = useHistory();
  const { callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  let { logs, isLogLoading, logsInput, particularLog, activeLogs } = callReducer;
  const loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let userData:any = frameCallProfile(getCurrentCallDetail()||{});
  // console.log(filpcallConnected,"filpcallConnected===");
  let len = Math.round(logs?.length / 8);
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  const changeFilter = (val: any) => {
    let { leftSideWindow } = store.getState().updatedCallList;
    let sendingFilter: string = "";
    if (val.key === "Missed Calls") {
      sendingFilter = "MISSED";
    } else if (val.key === "Team Calls") {
      sendingFilter = "Groupcall";
    } else if (val.key === "Direct Calls") {
      sendingFilter = "Direct";
    } else sendingFilter = "All";
    cancelSelection();
    storeLogs([]);
    setcallliststate({ ...callListState, filterType: val.key, isClear: false });
    getCallLogsCDR(leftSideWindow === "callList" ? 1 : 0, sendingFilter, logsInput.search);
  };
  const deleteEventTrigger = () => {
    setcallliststate({ ...callListState, isClear: true });
  };

  const handleScroll = (e: any) => {
    if (!isLogLoading) {
      const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
      if (bottom) {
        setcallliststate({
          ...callListState,
          listOffset: logsInput.offset + 1
        });
        // contactService.getCallListSoc(25, listOffset + 25);
        getCallLogsCDR(logsInput.offset + 1, logsInput.filter, logsInput.search);
      }
    }
  };

  const selectRecentCalls = (ext: any) => {
    setcallliststate({
      ...callListState,
      doneList: selectList(tempList, ext)
    });
  };
  const activeContact = useRef(null);
  const selectAll = (e: any) => {
    if (e.target.checked) {
      let allList = logs?.map((data: any) => {
        let key: string = data.serviceType === 'GroupCall' ? data.groupId : data.ext;
        return key;
      });
      setcallliststate({
        ...callListState,
        doneList: allList,
        tempList: allList
      });
    } else {
      cancelSelection();
    }
  };

  const isDelete = () => {
    tempList?.length > 0
      ? setcallliststate({ ...callListState, isModalVisible: true })
      : toastInformation("No call log selected", "warning");
  };

  const confirmDelete = () => {
    tempList.length === logs.length ? deleteAllRecentCalls() : deleteRecentCalls(doneList);;
    closeAll();
  };

  const cancelSelection = () => {
    setcallliststate({ ...callListState, doneList: [], tempList: [] });
  };

  const closeModal = () => {
    setcallliststate({ ...callListState, isModalVisible: false });
  };
  const closeAll = () => {
    setcallliststate({ ...callListState, isClear: false, isModalVisible: false, doneList: [], tempList: [] });
  };

  const videoMeet =(particularLog:any) =>{
    console.log(particularLog,"particularLog video call")
    if(particularLog?.ext) { 
      sendDirectVideoCallRequest(particularLog);  
  }
    else { toastInformation("Please check the number","failure"); }
  }


  const callDetailPage = (list: object) => {
    let { isProfileView } = store.getState().updatedCallList || {};
    if (isProfileView === true) {
      storeChatWindow(list);
    }
    closeAll();
    storeCallHistory([]);
    storeParticularLog(list, false);
    getCallHistoryByExt(1);
    max_Call_Window();
  };
  const filtermenu = (
    <Menu onClick={changeFilter} className="menufileters">
      <Menu.Item key={"All Calls"}>All Calls</Menu.Item>
      <Menu.Item key={"Direct Calls"}>Direct Calls</Menu.Item>
      <Menu.Item key={"Team Calls"}>Team Calls</Menu.Item>
      <Menu.Item key={"Missed Calls"}>Missed Calls</Menu.Item>
    </Menu>
  );

  const keyHandler = (ev: any) => {
    let startFocus: any = activeContact.current;
    if ((ev.keyCode === 38 || ev.keyCode === 40) && startFocus !== null) {
      let movingPosition: any = 0;
      if (particularLog) {
        movingPosition = handlingKeyMovement(ev);
        startFocus.scrollIntoViewIfNeeded();

        if (!movingPosition && movingPosition === undefined) movingPosition = 0;
        let { logs } = store.getState().callReducer || {};
        callDetailPage(logs[movingPosition]);
      }
    }
  };

  let filterTitle: string = "No recent calls yet";
  
  const activeLogRev = _.uniqBy([...activeLogs].reverse(), 'guid');
  if (filterType === "Missed") {
    filterTitle = "No missed calls yet";
  } else if (filterType === "Incoming") {
    filterTitle = "No incoming calls yet";
  } else if (filterType === "Outgoing") {
    filterTitle = "No outgoing calls yet";
  }

  useEffect(() => {
    window.addEventListener("keyup", (e: KeyboardEvent) => keyHandler(e));

    return () => {
      window.removeEventListener("keyup", keyHandler);
    };
  }, []);

  const sendToMain = (particularGroupDetail: any, status: boolean) => {
    openGroup(particularGroupDetail, status);
  }
  return (
    <>
      <div className={styles.recentListmain}>

        <div className={styles.rightbartop}>

          {/* ----------------------------------------------------------- */}
          {/* <div className={styles.lefts}>Recent Calls</div> */}
          <Dropdown overlay={filtermenu} placement="bottomLeft" trigger={["hover"]}>
            <div className={`makeactive ${styles.rights}`} onClick={(e) => e.preventDefault()}>
              <span className={styles.favchatIcn}></span>
              {filterType}
            </div>
          </Dropdown>
        </div>
        <div className={styles.clearLogLeft}>
          <div className={styles.checkBoxArea}>
            {isClear && (
              <URCheckBoxCall
                checked={tempList?.length === logs?.length ? true : false}
                onChange={(e: any) => selectAll(e)}
              />
            )}
          </div>
          <div className={styles.btnSec}>
            {tempList?.length > 0 && (
              <URButton
                className="urButton buttonTransparent fordeleting"
                name={tempList?.length === logs?.length ? "Delete All" : "Delete"}
                onClick={isDelete}
              />
            )}
            {isClear && <URButton onClick={closeAll} className="urButton buttonTransparent" name="Cancel" />}
            {!isClear && logs?.length > 0 && !isLogLoading ? (
              <URButton className="urButton buttonTransparent" name="Clear Log" onClick={deleteEventTrigger} />
            ) : null}
          </div>
        </div>

        {(logs?.length > 0 || activeLogRev?.length > 0) ? (
          <div className={`${styles.scrolllayerleft} ${"scrollerhover"} callfadein`} onScroll={handleScroll}>
            <>
              {!isClear && activeLogRev?.map((list: any, index: any) => {
                let message: any = searchHighlight(list, logsInput.search);
                let allusers: any = list?.caller_id?.split(",");
                let groupContact:any=list?.groupCallInfo?.IndividualDetails;
                let pstncontact:any = list?.groupCallInfo?.PSTNDetails;
                let partLength:any = list?.groupCallInfo?.GroupDetails;
                let value = ""
                if (list?.groupNames && Object.keys(list?.groupNames).length > 0) {
                  Object.keys(list?.groupNames).forEach((gKey: any) => {
                    let newKey: any = list?.groupNames[gKey];
                    Object.keys(newKey).forEach((member: any) => {
                      value += newKey[member];
                    });
                  });
                }
              return (
                  <div key={index} onClick={() => isClear && selectRecentCalls(list?.serviceType === 'GroupCall' ? list?.groupId : list?.ext)}>
                    <div
                      className={
                        list?.callStatus === "Hold"
                          ? `${styles.profilelists} ${styles.callhold}`
                          : `${styles.profilelists}  ${styles.callattend}`
                      }
                      ref={particularLog?.ext === list?.ext ? activeContact : null}
                    >
                      <div className={styles.linkclick}>
                        <URAvatarGroup
                          className={`lefts size38 mr8 colorBG2  ${(list?.ImageURL !== null && list?.ImageURL !== "")?'avatarWithImg':'' } ${styles.avatarname} `}
                          profileInfo={

                            // (list?.isGroupCall || list?.ImageURL === undefined || list?.ImageURL === '') ?
                            //   (<>
                            //     {allusers?.length === 1 && <span>{allusers[0]?.charAt(0).toUpperCase()}</span>}
                            //     {allusers?.length > 1 && (
                            //       <>
                            //         {" "}
                            //         <span>{allusers[0]?.charAt(0).toUpperCase()}</span>
                            //         <span>{allusers[1]?.charAt(0).toUpperCase()}</span>
                            //       </>
                            //     )}
                            //     {allusers?.length > 2 && <span>{allusers[2]?.charAt(0).toUpperCase()}</span>}
                            //     {allusers?.length > 3 && <span>{allusers[3]?.charAt(0).toUpperCase()}</span>}
                            //     {/* <URStatusDot className={userStatusColor(popOverValues?.user_status, colorValue)} /> */}
                            //                         {/* <span className="teamImgGroup"><img src={teamIcn} alt="team icon" /></span> */}

                            //   </>) :

                            //   (<>
                            //     <img src={list?.ImageURL} alt="" />
                            //      {/* <URStatusDot className={userStatusColor(list?.user_stastus, colorValue)} /> */}
                            //    </>)
                            !list.isGroupCall?(
                              list?.ImageURL !== "" ?
                              <>
                              <img src={list?.ImageURL} alt="" />
                            </>
                             : <><span>{list?.caller_id.charAt(0).toUpperCase()}</span>
                             </>
                            ):(
                              <>
                              { list?.ImageURL?
                              <img src={list?.ImageURL} alt="" />
                              :
                              //userTeamSplit
                              <span className="teamImg"><img src={teamIcn}  alt="team icon" /></span>
                            }
                            </> 
                            )

                          }
                        />

                        <div className={styles.vmsideDetails}>
                          <div className={styles.frow}>
                            {(logsInput?.search !== "" && message.key === "name" && activeLogRev?.length > 0)? (
                              <h4>
                                {message?.middleMsg !== "" ? (
                                  <>
                                    {message?.firstMsg}
                                    <b className={styles.highlight}>{message?.middleMsg}</b>
                                    {message?.lastMsg}
                                  </>
                                ) : (
                                  <>{list?.caller_id ? list?.caller_id : list?.combinedNames}</>
                                )}
                              </h4>
                            ) : (
                              <>                           
                              {
                                (list?.hasOwnProperty("combinedNames") && list?.combinedNames?.length >  0) ? 
                                <h4>
                                  {
                                    Object.keys(partLength)?.length === 0 &&(Object.keys(groupContact)?.length !== 0 || Object.keys(pstncontact)?.length !== 0) ? 
                                   
                                    ((list?.isHostId?.toString() === loggedUser?.ext?.toString()) ?'You + Others' :
                                    findCallHost(list?.isHostId) + ' + Others'):
                               
                                    (Object.keys(groupContact)?.length === 0 && Object.keys(pstncontact)?.length === 0) ? 
                                    list?.combinedNames[0] :
                                    (Object.keys(partLength)?.length !== 0 && (Object.keys(groupContact)?.length !== 0 || Object.keys(pstncontact)?.length !== 0)) ?
                                    value + '+ Others': ''


                                  }
                                </h4>
                                :
                                // ((list?.hasOwnProperty("combinedNames") && list?.combinedNames?.length ===  0 &&  (Object.keys(partLength)?.length === 0 && (Object.keys(groupContact)?.length === 0 && Object.keys(pstncontact)?.length === 0))) ? 
                                // <h4>{list?.caller_id}</h4> :
                                // <h4>{findCallHost(list?.isHostId) === undefined ? '' : findCallHost(list?.isHostId) + ' + Others'}</h4>
                                // )
                                ((list?.hasOwnProperty("combinedNames") && list?.combinedNames?.length === 0 &&
                              (Object.keys(partLength ?? {}).length === 0 &&
                                (Object.keys(groupContact ?? {}).length === 0 && Object.keys(pstncontact ?? {}).length === 0))) ?
                              <h4>{list.caller_id}</h4> :
                              <h4>{findCallHost(list?.isHostId) === undefined ? '' : findCallHost(list?.isHostId) + ' + Others'}</h4>
                            )
                          
                              
                               
                               }
                               </>
                            )}
                            {/* //&&( (list?.todeviceType&&list?.fromdeviceType)!=="URWEB:WEB"))
                          */}

                            {list?.callStatus === "Active" && <p>{list?.isGroupCall ? "Active Team Call" : "Active Call"} </p>}
                            {list?.callStatus === "On a call" && <p>On a call</p>}

                          </div>

                          <div className={styles.secondrow}>
                            {list?.callStatus === "Rejoin" && (<>
                              <button
                                className={styles.buttonrejoin}
                                onClick={(e: any) => initiateGroupCall("Rejoin", list)}
                              >
                                Rejoin
                              </button>
                            </>)}




                            <>
                              {list?.callStatus === "Active" && (
                                <div className={styles.callDuration}>
                                  {list?.connectingStatus === "Attended"
                                    ? list?.callduration
                                    : list?.connectingStatus}
                                  <span className={styles.hd}>HD</span>

                                </div>
                              )}
                            </>
                            <>
                              {list?.callStatus ===  "On a call" && (
                                <div className={styles.callDuration}> {list?.callduration}
                                   <span className={styles.hd}>HD</span>
                                </div>
                              )}
                            </>
                            <>
                              {list?.callStatus === "Hold" && (
                                <div className={styles.callDuration}>
                                  {list?.callduration}
                                  <span className={styles.hold}>On Hold</span>
                                </div>
                              )}
                            </>
                            

                            {list?.callStatus === "On a call"&&list?.connectingStatus === "Flip" && (
                                <button
                                  className={styles.buttonrejoin}
                                  onClick={(e: any) => initiateFlipCall(list, "audio")} >
                                  Flip
                                </button> )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
            <>
              {logs?.map((list: any, index: any) => {
                let message: any = searchHighlight(list, logsInput.search);
                let activeGroupIndex: number = _.findIndex(activeLogRev, { guid: list.groupId });

                if (activeGroupIndex === -1) {
                  return (
                    <div key={index} onClick={() => isClear && selectRecentCalls(list?.serviceType === 'GroupCall' ? (list?.groupId) : (list?.ext))}>
                      <div
                        className={particularLog?.serviceType === 'GroupCall' ? (particularLog?.groupId === list?.groupId
                          ? `${styles.profilelists} ${styles.active}`
                          : `${styles.profilelists}`) : (
                          (particularLog?.ext === list?.ext && list?.serviceType !== 'GroupCall')
                            ? `${styles.profilelists} ${styles.active}`
                            : `${styles.profilelists}`
                        )}
                        ref={particularLog?.serviceType === 'GroupCall' ? (particularLog?.groupId === list?.groupId ? activeContact : null) : (particularLog?.ext === list?.ext ? activeContact : null)}
                        onClick={() => !isClear && callDetailPage(list)}>


                        <div className={`${styles.clearSelect} ${styles.clearSelected}`}>
                          {isClear && (
                            list?.serviceType === 'GroupCall' ?
                              <URCheckBoxCall checked={tempList?.indexOf(list?.groupId) > -1 ? true : false} /> :
                              <URCheckBoxCall checked={tempList?.indexOf(list?.ext) > -1 ? true : false} />)}
                        </div>
                        <div className={styles.linkclick}>
                          <div onClick={() => list.serviceType === 'GroupCall' && sendToMain(list, !isClear)}>
                            <PopoverModule popOverValues={list} randomColor={random_color[index]} value={false} />
                          </div>
                          <div className={styles.vmsideDetails}>
                            <div className={styles.frow} >
                            {logsInput?.search !== "" && message.key === "name" ? (
                                <h4>
                                  {message?.middleMsg !== "" ? (
                                    <>
                                      {message?.firstMsg}
                                      <b className={styles.highlight}>{message?.middleMsg}</b>
                                      {message?.lastMsg}
                                    </>
                                  ) : (                                  
                                    <>{list?.callerId || list?.caller_id}</>
                                  )}
                                </h4>
                              ) : (
                                list?.serviceType ==="GroupCall"  ? <h4>{loggedUser.ext.toString() === list?.callingNo  ? "You"+ " + Others"  
                                :findCallHost(list?.callingNo) + " + Others" } </h4>            
                                : <h4>{list?.callerId || list?.caller_id}</h4>
                              )}
                              <p>
                                <span
                                  className={
                                    list?.callType === "OUTBOUND"
                                      ? styles.outGoingCall
                                      : list?.callType === "INBOUND"
                                        ? styles.incomingCall
                                        : styles.missedCall
                                  }
                                ></span>

                                <span
                                  className={
                                    list?.callType === "MISSED"
                                      ? `${styles.callSts} ${styles.callMissed}`
                                      : styles.callSts
                                  }
                                >
                                  {list?.callType === "OUTBOUND"
                                    ? "Outgoing"
                                    : list?.callType === "INBOUND"
                                      ? "Incoming"
                                      : "Missed"}
                                </span>
                                {list?.callType !== "MISSED" && (
                                  <span className={styles.callDuration}>
                                    {milliSecondsConverter(list?.callDuration)}{" "}

                                  </span>

                                )}
                              </p>

                            </div>
                            <div className={styles.secondrow}>
                              {logsInput?.search !== "" && message.key === "date" ? (
                                <span>
                                  {message?.middleMsg !== "" ? (
                                    <>
                                      {message?.firstMsg}
                                      <b className={styles.highlight}>{message?.middleMsg}</b>
                                      {message?.lastMsg}
                                    </>
                                  ) : (
                                    <>{timeStampConverter(list?.callDateTime, "list")}</>
                                  )}
                                </span>
                              ) : (
                                <span>{timeStampConverter(list?.callDateTime, "list")}</span>
                              )}
                            </div>
                            {(!isClear && list?.serviceType !== 'GroupCall') && (
                              <div className={styles.hoverdiv}>
                                <ul>
                                  <li>
                                    <Tooltip placement="top" title="Call">
                                      <span
                                      className={`${styles.iconCall} ${list?.is_blocked === 1 && 'blockdisabled'}`}
                                        onClick={() => initiateCall(list?.ext, "audio")}
                                      ></span>
                                    </Tooltip>
                                  </li>
                                  <li>
                                    <Tooltip placement="top" title="Chat">
                                      <span className={`${styles.iconChat} ${list?.is_blocked === 1 && 'blockdisabled'}`} onClick={() => goCalltoChat(list, history, '')}></span>
                                    </Tooltip>
                                  </li>
                                  <li>
                                    <Tooltip placement="top" title="Video Call">
                                      <span
                                       className={`${styles.iconMeet} ${list?.is_blocked === 1 && 'blockdisabled'}`}
                                        onClick={() => videoMeet(list)}
                                      ></span>
                                    </Tooltip>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
              {isLogLoading && (
                <div className="skeletonbottom">
                  <Lottie className="svgLoadinglist" animationData={ContactLoader}  />
                </div>
              )}{" "}
            </>
          </div>
        ) : isLogLoading ? (
          <>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]?.map(
              (index: any) => (
                <div key={index}>
                  <URChatLeftSkeleton />
                </div>
              )
            )}
          </>
        ) : (
          <NoContent image={callblank} title={filterTitle} description={""} />
        )}
      </div>

      <Modal
        title={tempList?.length === logs?.length ? "Delete all recent calls?" : "Delete selected recent calls?"}
        centered
        visible={isModalVisible}
        onOk={confirmDelete}
        onCancel={closeModal}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: "urButton buttonWhite" }}
        okButtonProps={{ className: "urButton buttonRed" }}
        className="customPopup"
      >
        {tempList?.length === logs?.length
          ? "Are you sure you want to permanently delete all recent calls?"
          : "Do you want to delete selected recent calls?"}
      </Modal>
    </>
  );
};
